/* eslint-disable-next-line */
import {
    DATE_RANGE_TYPE,
    FREQUENCY_DAILY,
    ScheduledReport,
} from '@givelify/api';
import dayjs from 'dayjs';
import { Reducer } from 'redux';
import {
    IntegrationState,
    IntegrationActions,
    SET_SCHEDULED_REPORT,
} from './types';

export const initialIntegrationState: IntegrationState = {
    scheduledReport: {
        name: 'ACS',
        id: 0,
        doneeId: 0,
        frequency: FREQUENCY_DAILY,
        scheduledDate: null,
        scheduledDay: null,
        receivesNotifications: false,
        reportType: 'ACS',
        reportTypeVersion: 'ACS People',
        nextRun: dayjs(),
        dateRangeType: DATE_RANGE_TYPE.DONATION,
        matchBy: 'name',
    },
};
export const initialScheduledReport: ScheduledReport = {
    name: null,
    id: null,
    doneeId: null,
    frequency: null,
    scheduledDate: null,
    scheduledDay: null,
    receivesNotifications: null,
    reportType: null,
    reportTypeVersion: null,
    nextRun: null,
    dateRangeType: null,
    matchBy: null,
};

export const IntegrationReducer: Reducer<
    IntegrationState,
    IntegrationActions
> = (state = initialIntegrationState, action) => {
    switch (action.type) {
        case SET_SCHEDULED_REPORT:
            return {
                ...state,
                scheduledReport: action.data,
            };
        default:
            return state;
    }
};

/**
 * Factory for easily producing a IntegrationReducer with a different initial state
 * Ideal for testing and cosmos
 *
 * @param initialState
 */
export const IntegrationReducerFactory =
    (initialState: IntegrationState) =>
    (state = initialState, action) =>
        IntegrationReducer(state, action);

export default IntegrationReducer;
